import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, defer, finalize } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';
import { SKIP_LOADING } from './loading.context';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private readonly loadingService: LoadingService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (this.shouldSkipLoading(request)) {
      return next.handle(request);
    }

    return defer(() => {
      this.loadingService.show();
      return next.handle(request).pipe(
        finalize(() => this.loadingService.hide()),
      );
    });
  }

  private shouldSkipLoading(request: HttpRequest<unknown>): boolean {
    const skipsLoading = request.context.get(SKIP_LOADING) || request.headers.has('X-Skip-Loading');
    const isBackendRequest = request.url.startsWith(environment.apiUrl);
    const isNonInteractiveRequest = ['HEAD', 'OPTIONS'].includes(
      request.method.toUpperCase(),
    );

    return skipsLoading || !isBackendRequest || isNonInteractiveRequest;
  }
}
